import * as React from "react";

function ExlamationErrorIcon(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={38} height={38} {...props} viewBox="0 0 38 38">
        <path
          id="Shape_Copy_2"
          data-name="Shape Copy 2"
          d="M19-14A19,19,0,1,0,38,5,19.022,19.022,0,0,0,19-14Zm0,26.126a1.189,1.189,0,0,1-1.187-1.187V-5.688A1.189,1.189,0,0,1,19-6.875a1.189,1.189,0,0,1,1.187,1.187V10.938A1.189,1.189,0,0,1,19,12.125Zm0,4.749a1.187,1.187,0,1,1,1.187-1.187A1.189,1.189,0,0,1,19,16.874Z"
          transform="translate(0 14)"
          fill="#f44336"
        />
      </svg>
    </span>
  );
}

export default ExlamationErrorIcon;
